import { render, staticRenderFns } from "./TheEditCategoriaLinae.vue?vue&type=template&id=7a1d7148&"
import script from "./TheEditCategoriaLinae.vue?vue&type=script&lang=js&"
export * from "./TheEditCategoriaLinae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports